import { getText, appendText } from '../../../assets/js/text-renderer';

import './pricing-analytics.scss';
import '../../shared/pricing-card.scss';
import '../../shared/faqs/faqs';

export const loadText = async () => {
  const data = await getText('platform/intelek-smart-analytics/intelek-smart-analytics-pricing');
  const content = data.stories[0].content;
  console.log(content);
  setFaqsContent(content);
};

function setFaqsContent(content) {
  const faqsContainer = document.getElementById('faqs');
  const faqsEl = document.createElement('custom-faqs');

  content.FAQS.forEach((faq) => {
    const faqElement = document.createElement('li');
    faqElement.setAttribute('title', faq.title);
    faqElement.setAttribute('content', faq.text);
    faqsEl.appendChild(faqElement);
  });

  faqsContainer.appendChild(faqsEl);

  appendText(content.any_more_questions, 'any_more_questions');
}
